var render = function render(){var _vm=this,_c=_vm._self._c;return _c('flat-pickr',{ref:"dateTimePicker",staticClass:"form-control",attrs:{"value":_vm.value,"id":_vm.data.id,"placeholder":_vm.data.label,"config":_vm.config,"disabled":_vm.data.disabled === 'disabled'},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }